<mat-card class="confirm-card">
  <mat-card-title data-at-dialog-title>
    {{ data?.title }}
    <button mat-icon-button [mat-dialog-close]="false" *ngIf="data?.closeIcon">
      <mat-icon>clear</mat-icon>
    </button>
  </mat-card-title>
  <mat-card-content data-at-dialog-body [innerHTML]="data.content | viTrustHtml">
  </mat-card-content>
  <mat-card-actions class="flex flex-row xs:flex-col-reverse gap-[8px] justify-center items-center">
    <button
      *ngIf="data?.cancelBtn"
      data-at-dialog-btn-cancel
      id="cancel-btn"
      mat-stroked-button
      color="primary"
      (click)="onCancel()"
    >
      {{ data?.cancelBtn }}
    </button>
    <button
      *ngIf="data?.confirmBtn"
      data-at-dialog-btn-confirm
      id="confirm-btn"
      mat-raised-button
      color="primary"
      (click)="onConfirm()"
    >
      {{ data?.confirmBtn }}
    </button>
  </mat-card-actions>
</mat-card>
